import React, {useEffect, useState} from "react";
import {useLocation, useSearchParams} from "react-router-dom";
import './../App.css';
import "./css/result.css";
import resultRank from './../assets/resultRank.svg';
import axios from "axios";

const Result = () => {
    // topからの値受け取り
    const location = useLocation();
    const [queryParams] = useSearchParams();
    const name = queryParams.get("name");
    const userId = queryParams.get("id");
    const [recommend, setRecommend] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        try {
            axios.get(
                "https://dots-to-code2024-back.onrender.com" + "/user/" + userId + "/recommend",
            ).then(
                (response) => {
                    const res = JSON.parse(response.data);
                    console.log(res["recommend_list"])
                    setRecommend(res["recommend_list"]);
                    setIsLoading(false);
                }
            );
            console.log(recommend);
        } catch (error) {
            console.error("エラーが発生しました:", error);
        }
    }, []);
    return (isLoading ? <div>loading...</div> :
            <div className="result section">
                <div className="result__text">{name}さんがもらって嬉しいものTop3</div>
                <div className="result__ranking">
                    {recommend && recommend.length > 0 ?
                        <>
                            <div className="result__rank">
                                <div className="number__1"><img src={resultRank} alt="1"/></div>
                                <div className="">{"　"}</div>
                                <a href={recommend[0].url} rel="noopener norefferer">
                                    <div className="name__1">{recommend[0].name}
                                    </div>
                                </a>
                            </div>
                            {recommend.slice(1).map((item, index) => {
                                return (
                                    <div className="result__rank">
                                        <div className="number__2">{index + 2}</div>
                                        <div className="">{"　"}</div>
                                        <a href={item.url} rel="noopener norefferer">
                                            <div className="name__2">{item.name}</div>
                                        </a>
                                    </div>
                                );
                            })}
                        </>
                        : <div>データがありません</div>}
                </div>
            </div>
    )
        ;
};

export default Result;